$( document ).ready(function() {

  /*******************************************************************************
   *  Site Header Scroll Behavior
   ******************************************************************************/

  var scrollPos = 0;
  var scrollPosTop = 0;
  var scrollPosBottom = 0;

  document.addEventListener("scroll", (event) => {

    if(window.scrollY < 120) {
      showFullHeader();
      scrollPosTop = window.scrollY;
      scrollPosBottom = window.scrollY;
    } else {
      if(scrollPos < window.scrollY) {
        // User is scrolling down

        if(
          // User has to scroll down 100 pixels to trigger
          scrollPosBottom <= window.scrollY
          && window.scrollY - scrollPosBottom > 100
        ) {
          showScrollHeader();
        }

        scrollPosTop = window.scrollY;
      } else {
        // User is scrolling up

        if(
          // User has to scroll up 200 pixels to trigger
          scrollPosTop >= window.scrollY
          && scrollPosTop - window.scrollY > 200
        ) {
          showFullHeader();
        }

        scrollPosBottom = window.scrollY;
      }
    }

    scrollPos = window.scrollY;
  });

  function showFullHeader() {
    if($('#wrapper-header').hasClass('scrolled')) {
      $('#wrapper-header').removeClass('scrolled');
    }
  }

  function showScrollHeader() {
    if(!$('#wrapper-header').hasClass('scrolled')) {
      $('#wrapper-header').addClass('scrolled');
    }
  }

  /*******************************************************************************
   *  Contrast Button
   ******************************************************************************/

  $('#toggle-contrast').on('click', function() {
    if($('html').attr('data-bs-theme') === 'dark') {
      $('html').attr('data-bs-theme', 'light');
      document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
    } else {
      $('html').attr('data-bs-theme', 'dark');
      document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
    }
  });

  $('#toggle-contrast-mobile').on('click', function() {
    if($('html').attr('data-bs-theme') === 'dark') {
      $('html').attr('data-bs-theme', 'light');
      document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
    } else {
      $('html').attr('data-bs-theme', 'dark');
      document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
    }
  });

  let contrastCookie = document.cookie.split('; ').find(row => row.startsWith('contrast='));
  if(contrastCookie) {
    contrastCookie = contrastCookie.split('=')[1];
    $('html').attr('data-bs-theme', contrastCookie);
  }

});
